import React from "react";
import ShowContainer from "../../../../mui/ShowContainer";
import { useTranslation } from "react-i18next";
import IconTimeCircle from "../../../../mui/JSXIcons/IconTimeCircle";
import "./bonus-time.scss";

export default function BonusTime({ activeTo, isTime }) {
  const { t } = useTranslation();
  const isExpired = activeTo && new Date(activeTo) < new Date();

  const getDateTime = (dataTime) => {
    try {
      const [date, time] = dataTime.split(" ");
      const newDate = new Date(date).toLocaleDateString();
      let timeString = newDate;
      if (isTime) timeString += ` ${time}`;

      return timeString;
    } catch (e) {
      return dataTime;
    }
  };

  return (
    <ShowContainer condition={activeTo}>
      <div className="bonus__activated__time">
        <IconTimeCircle />
        {isExpired ? (
          t("Expired")
        ) : (
          <span>
            {t("Bonus available until")}: <span className="accent">{getDateTime(activeTo)}</span>
          </span>
        )}
      </div>
    </ShowContainer>
  );
}
